import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Button } from '@mui/material';
import ProductDetails from './ProductDetails';
import { getFungicideStats as getAllStats } from '../../../lib/api';
import Dialog from '../../../components/DraggableModal';
import { usePermission } from '../../../hooks/use-permission';

FieldDetails.propTypes = {
  field: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  reloadFields: PropTypes.func.isRequired,
};

export default function FieldDetails(props) {
  const { field, handleClose, reloadFields } = props;

  const [tabs, setTabs] = useState([]);
  const [stats, setStats] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);
  const [currentStats, setCurrentStats] = useState(null);
  const [actions, setActions] = useState([]);
  const canAdjust = usePermission('RUN_RX');

  const onChange = useCallback(
    (changedStats) => {
      setStats(
        stats.map((statsForProduct) =>
          statsForProduct.key === changedStats.key
            ? changedStats
            : statsForProduct,
        ),
      );
      reloadFields();
    },
    [reloadFields, stats],
  );

  useEffect(getAllStatsEffect, [field]);
  useEffect(setTabsEffect, [stats]);
  useEffect(setCurrentStatsEffect, [stats, currentTab]);

  const dialogProps = {
    maxWidth: 'md',
    fullWidth: true,
    handleClose,
    title: field.fieldName,
    actions: buildButtons(),
  };

  const tabBarProps = {
    style: { marginLeft: -24, marginRight: -24 },
    variant: 'scrollable',
    value: currentTab,
    onChange: onTabChange,
  };

  return (
    <Dialog {...dialogProps}>
      <Tabs {...tabBarProps}>{tabs.map(buildTab)}</Tabs>
      {tabs.map(buildTabContent)}
    </Dialog>
  );

  function getAllStatsEffect() {
    getAllStats(field.aaManagedId).then(setStats);
  }

  function setTabsEffect() {
    if (!stats) return;
    setTabs(stats.map(({ key, label }) => ({ key, label })));
  }

  function setCurrentStatsEffect() {
    if (!stats) return;
    setCurrentStats(stats[currentTab]);
  }

  function buildTab({ label, key }) {
    return <Tab label={label} key={key} />;
  }

  function buildTabContent({ key }) {
    if (key === currentStats?.key)
      return (
        <ProductDetails
          key={currentStats.key}
          stats={currentStats}
          setActions={setActions}
          onChange={onChange}
        />
      );
  }

  function onTabChange(_, index) {
    setCurrentTab(index);
  }

  function buildButtons() {
    if (!canAdjust) return undefined;

    return (
      <>
        {actions.map((action) => action)}
        <Button onClick={handleClose} variant="contained">
          Close
        </Button>
      </>
    );
  }
}
